var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.foot))?_c('div',{attrs:{"id":"footerDiv"}},[(!_vm.isApp)?_c('div',{staticClass:"copy-rights text-center pt-2 pb-2"},[_c('p',{staticClass:"m-0"},[_vm._v("2017 labotist . All rights reserved.")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15eb72c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Footer.vue
// module id = null
// module chunks = 